import React from "react";
import { cn } from "../../../../shadcn/lib/utils";

interface TimerDisplayProps {
  hours: number;
  minutes: number;
  seconds: number;
  status: string;
  endTime?: number;
  extendTimeAt?: string;
}

export default function TimerDisplay({
  hours,
  minutes,
  seconds,
  status,
  endTime,
  extendTimeAt,
}: TimerDisplayProps) {
  const formatTime = () => {
    if (status !== "live") {
      return "00:00:00";
    }
    const h = hours < 10 ? `0${hours}` : hours;
    const m = minutes < 10 ? `0${minutes}` : minutes;
    const s = seconds < 10 ? `0${seconds}` : seconds;
    // Always show HH:MM:SS format for consistency
    return `${h}:${m}:${s}`;
  };

  const getTimerColor = () => {
    if (status !== "live" || !endTime) {
      return "timer-gray";
    }

    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    const extendTimeSeconds = extendTimeAt
      ? parseInt(extendTimeAt) * 60
      : 300; // Default 5 minutes
    const redThreshold = 240; // 4 minutes
    const orangeThreshold = Math.max(2400, extendTimeSeconds); // 40 minutes or extend time

    if (totalSeconds <= redThreshold) {
      return "timer-red";
    } else if (totalSeconds <= orangeThreshold) {
      return "timer-orange";
    } else {
      return "timer-green";
    }
  };

  return (
    <div className="text-right">
      <div className="text-[13px] text-gray-500 mb-1">Time Left</div>
      <div
        className={cn(
          "text-[32px] font-bold px-3 py-1 rounded-lg inline-block min-w-[150px] text-center border-2",
          {
            "bg-green-50 text-green-700 border-green-200": getTimerColor() === "timer-green",
            "bg-orange-50 text-orange-600 border-orange-200": getTimerColor() === "timer-orange",
            "bg-red-50 text-red-700 border-red-200 animate-pulse": getTimerColor() === "timer-red",
            "bg-gray-50 text-gray-500 border-gray-200": getTimerColor() === "timer-gray",
          }
        )}
      >
        {formatTime()}
      </div>
    </div>
  );
}

